import classNames from 'classnames';

import CompareByPicker from './components/CompareByPicker';
import FilterBar from './components/FilterBar';

import type { Facet, GlobalFilterSelection } from './utilities/types';

import styles from './_index.module.scss';

export { MAX_FILTERS } from './utilities/constants';
export { automaticallyIncludesAllCompareValues } from './utilities/helpers';
export type { Facet, FacetOption, FilterCategory } from './utilities/types';
export type { CompareBy, FilterLogic, FilterRow, GlobalFilterSelection } from './utilities/types';

/** A blank selection consumers can seed local state with. */
export const EMPTY_GLOBAL_FILTER_SELECTION: GlobalFilterSelection = {
  compareBy: null,
  logic: 'AND',
  rows: [],
};

export type GlobalFiltersProps = {
  className?: string;
  facets: Facet[];
  onChange: (selection: GlobalFilterSelection) => void;
  selection: GlobalFilterSelection;
};

/**
 * Source-agnostic, presentational Compare By + Filters picker. It performs no
 * filtering itself: a consumer supplies a normalized `facets` model and the
 * current `selection`, and receives changes via `onChange`. See
 * `utilities/types.ts` for the contract.
 */
const GlobalFilters = ({ className, facets, onChange, selection }: GlobalFiltersProps) => (
  <div className={classNames(styles['global-filters'], className)} data-testid="global-filters">
    <CompareByPicker
      facets={facets}
      onChange={(compareBy) => onChange({ ...selection, compareBy })}
      value={selection.compareBy}
    />
    <FilterBar
      facets={facets}
      logic={selection.logic}
      onLogicChange={(logic) => onChange({ ...selection, logic })}
      onRowsChange={(rows) => onChange({ ...selection, rows })}
      rows={selection.rows}
    />
  </div>
);

export default GlobalFilters;
